interface NavigatorLike {
  userAgent: string;
  platform: string;
  maxTouchPoints: number;
}

const serverSide: NavigatorLike = { userAgent: "", platform: "", maxTouchPoints: 0 };

/**
 * iPhone, iPod i iPad. iPad u režimu "desktop sajt" javlja se kao Mac, pa se
 * prepoznaje po dodiru; običan Mac računar nije iOS.
 *
 * Fajl nema uvoza namerno: koristi ga i `usePWAInstall` (hooks), a ostatak
 * `shared` uvozi hooks, pa bi uvoz preko `@shared` napravio krug.
 */
export const isIOS = (
  nav: NavigatorLike = typeof navigator === "undefined" ? serverSide : navigator,
): boolean =>
  /iPad|iPhone|iPod/.test(nav.userAgent) ||
  (nav.platform === "MacIntel" && nav.maxTouchPoints > 1);
